// src/admin/pages/AdminFeedbackPage.jsx
// Route wrapper for the merchant feedback list — mirrors AdminMerchants.jsx:
// RequireAdmin gate + AdminLayout chrome around the AdminFeedback panel.
// The panel itself (data fetching, filters, pagination) lives in
// admin/components/AdminFeedback.jsx.

import RequireAdmin from "@/admin/components/RequireAdmin";
import AdminLayout from "@/admin/components/AdminLayout";
import AdminFeedback from "@/admin/components/AdminFeedback";

function AdminFeedbackPageInner() {
  return (
    <AdminLayout>
      <div className="mx-auto max-w-5xl">
        <AdminFeedback />
      </div>
    </AdminLayout>
  );
}

export default function AdminFeedbackPage() {
  return (
    <RequireAdmin>
      <AdminFeedbackPageInner />
    </RequireAdmin>
  );
}
